var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cookie-notify" }, [
    _c("div", {
      staticClass: "cookie-close",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "cookie-text" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }